import React from 'react';
import { Tag } from 'antd';
import { labelOf } from '../../Constants/enums';

/**
 * Enum-driven status tag. Pass a numeric `value` plus the matching `labels`
 * and (optional) `colors` maps from Constants/enums so every numeric status in
 * the app renders as a readable, consistently coloured label.
 */
const StatusTag = ({ value, labels, colors }) => {
  if (value === null || value === undefined) return <span>-</span>;
  const color = colors ? colors[value] : undefined;
  return <Tag color={color}>{labelOf(labels, value)}</Tag>;
};

export default StatusTag;
